export default {
    url: '',
    template: '<manage-settings-licences-list><manage-settings-licences-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/licences/list/index.js